import type { ApiResponse, CreateFeedbackIssueRequest, FeedbackIssueResponse } from '@kangaroo/shared';

import { api } from '../lib/api';

export async function submitFeedbackIssue(payload: CreateFeedbackIssueRequest, attachments: File[] = []) {
  if (attachments.length > 0) {
    const formData = new FormData();
    formData.append('payload', JSON.stringify(payload));
    attachments.forEach((file) => formData.append('attachments', file));

    const response = await api.post<ApiResponse<FeedbackIssueResponse>>('/support/feedback', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  }

  const response = await api.post<ApiResponse<FeedbackIssueResponse>>('/support/feedback', payload);
  return response.data.data;
}
